package com.mithkumaran.components

import androidx.compose.runtime.Composable
import com.mithkumaran.AboutSectionDesignationStyle
import com.mithkumaran.AboutSectionHeadingStyle
import com.mithkumaran.AboutTextStyle
import com.mithkumaran.utils.Res
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun LeftSide(
    colorMode: ColorMode,
    breakpoint: Breakpoint
) {
    Column(
        modifier = Modifier
            .fillMaxSize()
            .padding(all = 40.px),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = if (breakpoint <= Breakpoint.SM)
            Alignment.CenterHorizontally else Alignment.Start
    ) {
        SpanText(
            text = Res.String.NAME,
            modifier = AboutSectionHeadingStyle.toModifier()
                .margin(bottom = 12.px)
                .fontFamily(Res.Font.MONTSERRAT_EXTRA_BOLD)
                .color(if (colorMode.isLight) Res.Colors.GREEN_VOGUE else Res.Colors.WHITE)
                .fontWeight(FontWeight.Bold)
                .textAlign(
                    if (breakpoint <= Breakpoint.SM) TextAlign.Center
                    else TextAlign.Start
                )
        )
        SpanText(
            text = Res.String.PROFESSION,
            modifier = AboutSectionDesignationStyle
                .toModifier()
                .margin(bottom = 24.px)
                .fontFamily(Res.Font.MONTSERRAT_SEMI_BOLD)
                .color(if (colorMode.isLight) Res.Colors.GREEN_VOGUE else Res.Colors.WHITE)
        )
        Surface(
            modifier = Modifier
                .height(2.px)
                .fillMaxWidth()
                .margin(bottom = 24.px)
                .background(
                    if (colorMode.isLight) Res.Colors.GREEN_VOGUE
                    else Res.Colors.WHITE
                )
                .align(
                    if (breakpoint <= Breakpoint.SM) Alignment.CenterHorizontally
                    else Alignment.Start
                )
        ) {}
        SpanText(
            modifier = AboutTextStyle.toModifier()
                .fontFamily(Res.Font.MONTSERRAT_MEDIUM)
                .color(if (colorMode.isLight) Res.Colors.GREEN_VOGUE else Res.Colors.WHITE)
                .opacity(50.percent)
                .lineHeight(2)
                .margin(bottom = 36.px)
                .textAlign(
                    TextAlign.Justify
                ),
            text = "MSci student at University College London, specializing in Synthetic Organic Chemistry, Neuroscience, and Psychology. With 2+ years of hands-on experience in laboratory settings, I have developed a strong foundation in research methodologies, data analysis, and critical thinking. My passion for neuroscience led me to spearhead a student-led research project exploring the impact of organic compounds on neural pathways. As an active member of the British Neuroscience Association, I am committed to staying abreast of the latest developments in the field."
        )
    }
}